import { IDropdownOption } from '../../shared'
import { SortingOptions } from '../../../enums/sorting-options.enums'

export const sortOptions: IDropdownOption[] = [
  {
    label: 'Default',
    value: SortingOptions.DEFAULT
  },
  {
    label: 'Alphabetical A-Z',
    value: SortingOptions.ALPHA_ASC
  },
  {
    label: 'Alphabetical Z-A',
    value: SortingOptions.ALPHA_DESC
  }
]
